var React = require('react');

function VektorMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.6665 14.6667H20.3332M1.6665 7.99999H20.3332M1.6665 1.33333H20.3332","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

VektorMenu.defaultProps = {"width":"22","height":"16","viewBox":"0 0 22 16","fill":"none"};

module.exports = VektorMenu;

VektorMenu.default = VektorMenu;
